/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getStoreStockPage = (props: IncomingContent): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'StoreStockPage', id: 'Store-Stock-Page' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	}	
}); 